import { Directive, HostListener } from '@angular/core';

/**
 * Apply to any wrapper element (e.g. cm-text-field) to auto-select the inner
 * <input> content when the user focuses the field, allowing immediate overtype.
 * Uses `focusin` because it bubbles, unlike the native `focus` event.
 */
@Directive({ selector: '[selectOnFocus]' })
export class SelectOnFocusDirective {
  @HostListener('focusin', ['$event'])
  onFocusIn(event: FocusEvent): void {
    const target = event.target as HTMLInputElement;
    if (target?.tagName === 'INPUT') {
      target.select();
    }
  }
}
